module.exports = __webpack_public_path__ + "static/img/morphet3.2972ac0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/testimonial/morphet3.png
// module id = lfFj
// module chunks = 38